import { createContext, useContext, type ReactNode } from 'react';
import { RootStore } from './RootStore';

const rootStore = new RootStore();
const StoreContext = createContext<RootStore>(rootStore);

export function StoreProvider({ children }: { children: ReactNode }) {
  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;
}

export function useStore(): RootStore {
  return useContext(StoreContext);
}

// Direct singleton accessors for non-React code (e.g. axios interceptor needing
// to call store.authStore.logout). Prefer useStore() inside components.
export { rootStore };
export type { RootStore };
